import { ActionTypesFactory } from "../../config/helper";

export const Addresses = ActionTypesFactory("Orders", "Addresses");
export const OrderHistory = ActionTypesFactory("Orders", "History");
export const OrderAddComments = ActionTypesFactory("Orders", "AddComments");
export const OrderGetComments = ActionTypesFactory("Orders", "GetComments");
export const OrderUpdate = ActionTypesFactory("Orders", "OrderUpdate");
export const Regions = ActionTypesFactory("Orders", "Regions");
export const Products = ActionTypesFactory("Orders", "Products");
export const ProductFilters = ActionTypesFactory("Orders", "ProductFilters");
export const AddToCart = ActionTypesFactory("Orders", "AddToCart");
export const UpdateCart = ActionTypesFactory("Orders", "UpdateCart");
export const DeleteItemFromCart = ActionTypesFactory(
  "Orders",
  "DeleteItemFromCart"
);
export const GetCart = ActionTypesFactory("Orders", "GetCart");
export const CreateOrder = ActionTypesFactory("Orders", "Create");
export const GetOrders = ActionTypesFactory("AdminOrders", "GetOrders");
export const GetOrder = ActionTypesFactory("AdminOrders", "GetOrder");
export const OrderRepeat = ActionTypesFactory("Orders", "OrderRepeat");
export const STORED_ORDER = "STORED_ORDER";
export const GetProfomaDoc = ActionTypesFactory("Orders", "GetProfomaDoc");
export const UpdateProfomaDoc = ActionTypesFactory(
  "Orders",
  "UpdateProfomaDoc"
);

export const get_proforma_doc = (payload) => {
  return {
    type: GetProfomaDoc.REQUEST,
    payload,
  };
};

export const update_sales_order_status = (payload) => {
  return {
    type: UpdateProfomaDoc.REQUEST,
    payload,
  };
};

export const order_history = (payload) => {
  return {
    type: OrderHistory.REQUEST,
    payload,
  };
};

export const order_add_comments = (payload) => {
  return {
    type: OrderAddComments.REQUEST,
    payload,
  };
};

export const order_get_comments = (payload) => {
  return {
    type: OrderGetComments.REQUEST,
    payload,
  };
};

export const add_to_cart = (payload) => {
  return {
    type: AddToCart.REQUEST,
    payload,
  };
};
export const order_update = (payload) => {
  return {
    type: OrderUpdate.REQUEST,
    payload,
  };
};

export const get_orders = (payload) => {
  return {
    type: GetOrders.REQUEST,
    payload,
  };
};

export const get_prod_filters = (payload) => {
  return {
    type: ProductFilters.REQUEST,
    payload,
  };
};

export const get_order = (payload) => {
  return {
    type: GetOrder.REQUEST,
    payload,
  };
};

export const update_cart = (payload) => {
  return {
    type: UpdateCart.REQUEST,
    payload,
  };
};

export const del_from_cart = (payload) => {
  return {
    type: DeleteItemFromCart.REQUEST,
    payload,
  };
};

export const get_cart = (payload) => {
  return {
    type: GetCart.REQUEST,
    payload,
  };
};

export const get_addresses = (payload) => {
  return {
    type: Addresses.REQUEST,
    payload,
  };
};

export const store_addr_details = (payload) => {
  return {
    type: STORED_ORDER,
    payload,
  };
};

export const get_products = (payload) => {
  return {
    type: Products.REQUEST,
    payload,
  };
};

export const get_regions = (payload) => {
  return {
    type: Regions.REQUEST,
    payload,
  };
};

export const create_orders = (payload) => {
  return {
    type: CreateOrder.REQUEST,
    payload,
  };
};

export const order_repeat = (payload) => {
  return {
    type: OrderRepeat.REQUEST,
    payload,
  };
};
